import React, { useCallback, useMemo } from 'react';

import { VisibilitySettingsType } from '@/types/schema';

import VisibilitySettingsFormField from '../../index';
import { VisibilitySettingsFormFieldProps } from '../../types';
import { adaptToGroupIds, adaptToRestrictionConfig } from '../../utils';

const LegacyVisibilitySettingsFormField: React.FC<VisibilitySettingsFormFieldProps> = (props) => {
  const { value, onChange, ...restProps } = props;

  const adaptedValue = useMemo(() => adaptToRestrictionConfig(value), [value]);

  const adaptedOnChange = useCallback(
    (value: VisibilitySettingsType) => {
      onChange(adaptToGroupIds(value));
    },
    [onChange],
  );

  return (
    <VisibilitySettingsFormField value={adaptedValue} onChange={adaptedOnChange} {...restProps} />
  );
};

export default LegacyVisibilitySettingsFormField;
